module.exports = __webpack_public_path__ + "img/KOSCA_SNB.c7c78e80.svg";